import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Always scroll to top for product detail pages
    if (pathname.startsWith('/product/')) {
      window.scrollTo(0, 0);
      return;
    }
    
    // Don't scroll to top if we're returning to index with scroll state or have stored product to scroll to
    const hasScrollState = window.history.state?.scrollToProduct;
    const hasStoredScrollProduct = sessionStorage.getItem('scrollToProduct') || sessionStorage.getItem('lastViewedProduct');
    
    if (!hasScrollState && !hasStoredScrollProduct) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;